const fillDispatchTypes = (dispatchTypes) => {
  return { type: 'FILL_DISPATCH_TYPES', payload: dispatchTypes };
};

export {
  fillDispatchTypes,
}